import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { LoadScript, Autocomplete } from "@react-google-maps/api";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateClientOrders,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState({
    customer_detail: {
      customer_name: "",
      customer_phone: "",
    },
    delivery_address: {
      lat: "",
      lng: "",
    },
  });

  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [clients, setClients] = useState([]);
  const [hubs, setHubs] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [autocomplete, setAutocomplete] = useState(null);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data(select_data);
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        hub_id: select_data.hub_id?._id,
        client_id: select_data.client_id?._id,
        vehicle_id: select_data.vehicle_id?._id,
        driver_id: select_data.driver_id?._id,
        daUserId: select_data.daUserId?._id,
      }));
    }
  }, [select_data, hubs, clients, users, vehicles]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "lat" || name === "lng") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        delivery_address: { ...prevData.delivery_address, [name]: value },
      }));
    } else if (name === "customer_name" || name === "customer_phone") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        customer_detail: { ...prevData.customer_detail, [name]: value },
      }));
    } else if (name === "hub_id") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        hub_id: { ...prevData.hub_id, [name]: value },
      }));
    } else if (name === "client_id") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        client_id: { ...prevData.client_id, [name]: value },
      }));
    } else if (name === "daUserId") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        daUserId: { ...prevData.daUserId, [name]: value },
      }));
    } else if (name === "driver_id") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        driver_id: { ...prevData.driver_id, [name]: value },
      }));
    } else if (name === "vehicle_id") {
      setUpdate_modal_data((prevData) => ({
        ...prevData,
        vehicle_id: { ...prevData.vehicle_id, [name]: value },
      }));
    } else {
      setUpdate_modal_data({ ...update_modal_data, [name]: value });
    }
  };
  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };
  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();

      // Ensure place has geometry data
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setUpdate_modal_data((prevFormData) => ({
          ...prevFormData,
          address: place.formatted_address,
          delivery_address: { lat, lng }, // Fixed: Match lat & lng
        }));
      } else {
        console.log("No location data available for this place.");
      }
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if (!update_modal_data.client_id)
      newErrors.client_id = "Client name is required";
    if (!update_modal_data.hub_id) newErrors.hub_id = "Hub is required";
    if (!update_modal_data.order_status)
      newErrors.order_status = "Order Status is required";
    if (!update_modal_data.delivery_date)
      newErrors.delivery_date = "Delivery Date is required";

    if (!update_modal_data.driver_id)
      newErrors.driver_id = "Driver ID is required";
    if (!update_modal_data.vehicle_id)
      newErrors.vehicle_id = "Vehicle ID is required";
    if (!update_modal_data.delivery_address)
      newErrors.delivery_address = "Delivery Address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");
    const userRole = localStorage.getItem("userRole"); // Get user role

    if (!validateFields()) {
      Swal.fire("Please fill in all required fields", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          // Determine API URL based on role
          let apiUrl;
          if (userRole === "superadmin") {
            apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/client-order/${_id}`;
          } else if (userRole === "admin") {
            apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/admin/clientorders/${_id}`;
          } else if (userRole === "clientmanager") {
            apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v3/clientmanager/clientorders/${_id}`;
          } else {
            console.error("Unauthorized role:", userRole);
            return;
          }

          // Create a new FormData object
          const formData = new FormData();
          formData.append("client_id", update_modal_data.client_id);
          formData.append("hub_id", update_modal_data.hub_id);
          formData.append("order_status", update_modal_data.order_status);
          formData.append("total_amount", update_modal_data.total_amount);
          formData.append("delivery_date", update_modal_data.delivery_date);
          formData.append("driver_id", update_modal_data.driver_id);
          formData.append("vehicle_id", update_modal_data.vehicle_id);
          //   formData.append("daUserId", update_modal_data.daUserId);
          if (update_modal_data.daUserId) {
            formData.append("daUserId", update_modal_data.daUserId);
          }

          formData.append(
            "customer_detail[customer_name]",
            update_modal_data.customer_detail.customer_name
          );
          formData.append(
            "customer_detail[customer_phone]",
            update_modal_data.customer_detail.customer_phone
          );
          formData.append(
            "delivery_address[lat]",
            update_modal_data.delivery_address.lat || ""
          );
          formData.append(
            "delivery_address[lng]",
            update_modal_data.delivery_address.lng || ""
          );
          formData.append("address", update_modal_data.address);

          const res = await axios.put(apiUrl, formData, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });

          if (res.data.success) {
            Swal.fire("Update success", "", "success");
            onUpdateClientOrders(update_modal_data);
            setRen(!ren);
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");
          console.error("Error updating orders:", error);
        }
        set_update_data_modal_Show(false);
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role

        if (!token) {
          console.error("No token found");
          return;
        }

        // Determine API URL based on role
        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/hubs`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/hubs`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        // Fetch data
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Update state
        setHubs(response.data.hubs);
      } catch (error) {
        console.error("Error fetching hubs:", error);
        setHubs([]);
      }
    };

    fetchHubs();
  }, [currentPage]);

  const handleHubChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      hub_id: value,
    }));
  };

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role

        if (!token) {
          console.error("No token found");
          return;
        }

        // Determine API URL based on role
        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/clients`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/clients`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/clients`;
        } else {
          console.error("Unauthorized role:", userRole);
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.clients)) {
          setClients(response.data.clients);
        } else {
          setClients([]);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]);
      }
    };

    fetchClients();
  }, []);
  const handleClientChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      client_id: value,
    }));
  };
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role

        if (!token) {
          console.error("No token found");
          return;
        }

        // Determine API URL based on role
        const apiUrl =
          userRole === "superadmin"
            ? `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`
            : `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/users`;

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.users)) {
          setUsers(response.data.users);
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, []);
  const handleUserChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      daUserId: value,
    }));
  };
  const handleDriverChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      driver_id: value,
    }));
  };

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        const userRole = localStorage.getItem("userRole"); // Get user role

        if (!token) {
          console.error("No token found");
          return;
        }

        let apiUrl;
        if (userRole === "superadmin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`;
        } else if (userRole === "admin") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/admin/vehicles`;
        } else if (userRole === "clientmanager") {
          apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/hub/client/vehicles`;
        } else {
          return;
        }

        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (Array.isArray(response.data.vehicles)) {
          setVehicles(response.data.vehicles);
        } else {
          setVehicles([]);
        }
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };

    fetchVehicles();
  }, []);

  const handleVehicleChange = (e) => {
    const { value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      vehicle_id: value,
    }));
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Client Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Vehicle *</Form.Label>
              <Form.Control
                as="select"
                name="vehicle_id"
                value={update_modal_data.vehicle_id || ""}
                onChange={handleVehicleChange}
                isInvalid={!!errors.vehicle_id}
              >
                <option value="">Select Vehicle</option>
                {vehicles.map((vehicle) => (
                  <option key={vehicle._id} value={vehicle._id}>
                    {vehicle.numberplate}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.vehicle_id}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Driver *</Form.Label>
              <Form.Control
                as="select"
                name="driver_id"
                value={update_modal_data.driver_id || ""}
                onChange={handleDriverChange}
                isInvalid={!!errors.driver_id}
              >
                <option value="">Select Driver</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.driver_id}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Hub *</Form.Label>
              <Form.Control
                as="select"
                name="hub_id"
                value={update_modal_data.hub_id || ""}
                onChange={handleHubChange}
                isInvalid={!!errors.hub_id}
              >
                <option value="">Select Hubs</option>
                {hubs.map((hub) => (
                  <option key={hub._id} value={hub._id}>
                    {hub.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.hub_id}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Client Name *</Form.Label>
              <Form.Control
                as="select"
                name="client_id"
                value={update_modal_data.client_id || ""}
                onChange={handleClientChange}
                isInvalid={!!errors.client_id}
              >
                <option value="">Select Clients</option>
                {clients.map((client) => (
                  <option key={client._id} value={client._id}>
                    {client.name}
                  </option>
                ))}
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.hub_id}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Order Status *</Form.Label>
              <Form.Control
                as="select"
                name="order_status"
                value={update_modal_data.order_status || ""}
                onChange={handleChange}
                isInvalid={!!errors.order_status}
              >
                <option value="Pending">Pending</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                {errors.order_status}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Total Amount </Form.Label>
              <Form.Control
                type="number"
                name="total_amount"
                value={update_modal_data.total_amount || ""}
                onChange={handleChange}
                isInvalid={!!errors.total_amount}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Delivery Date *</Form.Label>
              <Form.Control
                type="date"
                name="delivery_date"
                value={update_modal_data.delivery_date || ""}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Latitude *</Form.Label>
              <Form.Control
                type="text"
                name="lat"
                value={update_modal_data.delivery_address?.lat || ""}
                onChange={handleChange}
                isInvalid={!!errors.delivery_address}
              />
              <Form.Control.Feedback type="invalid">
                {errors.delivery_address}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Longitude *</Form.Label>
              <Form.Control
                type="text"
                name="lng"
                value={update_modal_data.delivery_address?.lng || ""}
                onChange={handleChange}
                isInvalid={!!errors.delivery_address}
              />
              <Form.Control.Feedback type="invalid">
                {errors.delivery_address}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Delivery Address *</Form.Label>
              <LoadScript
                googleMapsApiKey={process.env.REACT_APP_BASE_API}
                libraries={["places"]}
              >
                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                  <Form.Control
                    type="text"
                    placeholder="Search places..."
                    value={update_modal_data.address || ""}
                    onChange={(e) =>
                      setUpdate_modal_data({
                        ...update_modal_data,
                        address: e.target.value,
                      })
                    }
                    isInvalid={!!errors.delivery_address}
                  />
                </Autocomplete>
              </LoadScript>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>DA User ID </Form.Label>
              <Form.Control
                as="select"
                name="daUserId"
                value={update_modal_data.daUserId || ""}
                onChange={handleUserChange}
                isInvalid={!!errors.daUserId}
              >
                <option value="">Select User</option>
                {users.map((user) => (
                  <option key={user._id} value={user._id}>
                    {user.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Customer Name *</Form.Label>
              <Form.Control
                type="text"
                name="customer_name"
                value={update_modal_data.customer_detail.customer_name || ""}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Customer Phone Number *</Form.Label>
              <Form.Control
                type="number"
                name="customer_phone"
                value={update_modal_data.customer_detail.customer_phone || ""}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Client
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
